import { render, staticRenderFns } from "./ModalPlan.vue?vue&type=template&id=bc5ae4a2&scoped=true&"
import script from "./ModalPlan.vue?vue&type=script&lang=js&"
export * from "./ModalPlan.vue?vue&type=script&lang=js&"
import style0 from "./ModalPlan.vue?vue&type=style&index=0&id=bc5ae4a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5ae4a2",
  null
  
)

export default component.exports